import { money, money0 } from "../lib/api";

export const PoolTracker = ({ stats, compact }) => {
  if (!stats) return null;
  const pct = Math.min(100, (stats.pool_balance / stats.vacation_cost) * 100);
  return (
    <div data-testid="pool-tracker" className={`lux-card ${compact ? "p-6" : "p-8"} backdrop-blur-xl bg-[#1E263E]/80`}>
      <div className="flex items-baseline justify-between gap-4">
        <p className="eyebrow">{stats.label} · trip pool</p>
        <p className="font-mono-lux text-xs text-slate-400">{pct.toFixed(1)}%</p>
      </div>
      <p className="mt-3 font-mono-lux text-3xl md:text-4xl">
        <span data-testid="pool-balance" className="text-[#38BDF8]">{money(stats.pool_balance)}</span>
        <span className="text-slate-500 text-lg"> / {money0(stats.vacation_cost)}</span>
      </p>
      <div className="mt-5 h-2 rounded-full bg-white/5 overflow-hidden">
        <div className="h-full pool-fill rounded-full" style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-5 grid grid-cols-3 gap-3 text-xs text-slate-400">
        <div><p className="font-mono-lux text-white text-sm">From {money(stats.monthly_fee)}</p>monthly · <span className="text-[#38BDF8]">{money(stats.autopay_price)} autopay</span></div>
        <div><p className="font-mono-lux text-white text-sm">{100 - stats.owner_pct}%</p>of payments to pool</div>
        <div><a href="/mission" data-testid="pool-mission-link" className="inline-block py-1.5 font-mono-lux text-white text-sm hover:underline">Our mission</a><br />trade-school giving</div>
      </div>
    </div>
  );
};
